import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../services/auth.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit, OnChanges {

  @Input() enableBot: boolean;
  URL: string;
  openChatBot: boolean;
  secretKey: any;
  eCompany: any;

  constructor(
    public auth: AuthService,
  ) {
    if (this.auth.user.company) {
      this.URL = `${environment.assetURL}/chatbot/widget/bot`;
      this.secretKey = environment.secretKey;
      this.eCompany = CryptoJS.SHA256(this.auth.user.company.id.toString(), this.secretKey);
    }
  }

  ngOnInit() {
    this.openChatBot = false;
  }

  ngOnChanges() {
    this.toggleScripts(this.enableBot);
  }


  appendScript(d, s, id, baseUrl) {
    const fjs = d.getElementsByTagName(s)[0];
    let js;
    if (d.getElementById(id)) { return; }
    js = d.createElement(s);
    js.src = `${baseUrl}/t-${id}.min.js`;
    js.id = `cbs-${id}`;
    js.type = 'text/javascript';
    js.async = true;
    js.setAttribute('trobbit', 'true');
    fjs.parentNode.insertBefore(js, fjs);
  }

  removeScript(id) {
    document.getElementById(`cbs-${id}`).remove();
  }

  // Method to dynamically load JavaScript
  toggleScripts(valid: boolean) {
    if (valid && !this.openChatBot) {
      this.appendScript(document, 'script', this.eCompany, this.URL);
      this.openChatBot = true;
    }
  }
}
